<template>

	<div id="mobile-event-calendar" :class="{ 'loading' : loading }">

		<div class="calendar-utils">

			<div class="calendar-controls">

				<div class="month-switcher">

					<a href="#" title="Previous Month" :class="{ 'change-month previous-month' : true, 'disabled' : disablePreviousMonth }" @click.prevent="subtractMonth">

						<span class="text">Previous</span>

					</a>

					<span class="current-month">{{ month }} {{ year }}</span>

					<a href="#" title="Next Month" class="change-month next-month" @click.prevent="addMonth">

						<span class="text">Next</span>

					</a>

					<a href="#" class="change-to-current-month" v-if="! isCurrentMonth" @click.prevent="goToThisMonth">
						Return to current month
					</a>

				</div>

			</div>

		</div>

		<div v-if="! loading && ! monthHasEvents()" class="no-events-in-month">
			No Events Found In {{ month }} {{ year }}
		</div>

		<div class="days" v-else>

			<div v-for="day in daysInMonth"
				 :class="{
				 	'day' : true,
				 	'past': isDayInPast( year + '-' + month + '-' + day ),
				 	'current-day' : day == initialDate && month == initialMonth && year == initialYear
				 }">

				<div class="day-top">

					<span class="text">

						<span class="day-name">{{ getWeekDay( year + '-' + month + '-' + day ) }}</span>

						<span class="month-day">{{ getDaySuffix( year + '-' + month + '-' + day ) }}</span>

					</span>

				</div>

				<div class="events" v-if="dayHasEvents( year + '-' + month + '-' + day )">

					<div v-for="event in getEventsForDay( year + '-' + month + '-' + day )" :class="{ 'event': true, 'external' : event.external, 'fully-booked' : event.fully_booked }">

						<a :href="event.url" class="event-link" v-if="! isDayInPast( year + '-' + month + '-' + day )">

							<span class="event-title">
								<span :class="{ 'event-icon' : true, 'external' : event.external, 'fully-booked' : event.fully_booked }"></span>
								<span class="text"><span class="title">{{ event.title }}</span> <span class="price">{{ event.price }}</span></span>
							</span>

							<span class="view-link">
								<span v-if="event.fully_booked && event.waiting_list_enabled" class="text fully-booked">Join Waiting List</span>
								<span v-else-if="event.fully_booked" class="text fully-booked disabled">Fully Booked</span>
								<span v-else class="text book-now">Book Now</span>
							</span>

						</a>

						<div v-else class="event-link no-link">

							<span class="event-title">
								<span :class="{ 'event-icon' : true, 'external' : event.external, 'fully-booked' : event.fully_booked }"></span>
								<span class="text"><span class="title">{{ event.title }}</span> <span class="price">{{ event.price }}</span></span>
							</span>

							<span class="view-link">
								<span v-if="event.fully_booked && event.waiting_list_enabled" class="text fully-booked">Join Waiting List</span>
								<span v-else-if="event.fully_booked" class="text fully-booked disabled">Fully Booked</span>
								<span v-else class="text book-now">Book Now</span>
							</span>

						</div>

					</div>

				</div>

				<div v-else class="no-events">
					No Scheduled Events
				</div>

			</div>

		</div>

		<div class="calendar-keys">

				<span class="key standard">
					<span class="event-icon"></span>
					<span class="key-label">Event by Training Hub</span>
				</span>

			<span class="key external">
					<span class="event-icon external"></span>
					<span class="key-label">External Event</span>
				</span>

			<span class="key fully-booked">
					<span class="event-icon fully-booked"></span>
					<span class="key-label">Full Booked</span>
				</span>

		</div>


	</div>

</template>

<script>

	let moment = require( 'moment' );

	module.exports = {
		data : function () {
			return {
				loading: false,
				today: moment(),
				dateContext: moment(), // Will be changed so we can view other months
				events: {},
			}
		},
		computed: {
			year : function() {
				return this.dateContext.format( 'Y' );
			},
			month : function() {
				return this.dateContext.format( 'MMMM' );
			},
			dateObj : function() {
				return this.dateContext;
			},
			previousMonthObj : function() {
				return moment( this.dateContext ).subtract( 1, 'month' );
			},
			nextMonthObj : function() {
				return moment( this.dateContext ).add( 1, 'month' );
			},
			daysInMonth : function() {
				return this.dateContext.daysInMonth();
			},
			isPastMonth() {
				return this.dateContext.isBefore( this.today );
			},
			currentDate : function() {
				return this.dateContext.get( 'date' );
			},
			firstDayOfMonth : function() {
				let firstDay = moment( this.dateContext ).subtract( (this.currentDate - 1), 'days' );

				return firstDay.weekday();
			},
			initialDate : function() {
				return this.today.get( 'date' );
			},
			initialMonth : function() {
				return this.today.format( 'MMMM' );
			},
			initialYear : function() {
				return this.today.format( 'Y' );
			},
			initialDateObj : function() {
				return this.today;
			},
			disablePreviousMonth : function() {
				return this.previousMonthObj.isBefore( moment(), 'month' ) && !this.previousMonthObj.isSame( moment(), 'month' );
			},
			isCurrentMonth : function() {
				return this.dateObj.isSame( this.initialDateObj, 'month' );
			},
		},
		watch : {
			dateContext: function() {
				this.refreshEvents();
			}
		},
		mounted() {
			this.refreshEvents();
		},
		methods: {
			refreshEvents: function() {
				let firstDay = moment( this.dateContext ).subtract( ( this.currentDate - 1 ), 'days' ).weekday(),
					fromDate = firstDay !== 0 ? // If starts on sunday
						moment( this.dateContext ).subtract( 1, 'month' ).endOf( 'month' ).subtract( this.firstDayOfMonth - 1, 'days' ) : // Need to minus one day as is indexed from 0
						moment( this.dateContext ).startOf( 'month' ),
					toDate   = this.nextMonthDaysToFill ? // IF we are adding other dates from the next month
						moment( this.dateContext ).add( 1, 'month' ).startOf( 'month' ).add( ( this.nextMonthDaysToFill - 1 ), 'days' ) : // Need to minus one day as is indexed from 0
						moment( this.dateContext ).endOf( 'month' );

				this.updateEvents( fromDate, toDate );
			},
			updateEvents: function( fromDate, toDate ) {
				let data = {
					nonce: ScriptData.crate_get_events_nonce,
					action: 'crate_get_events',
					date_from: fromDate.format( 'Y-MM-DD' ),
					date_to: toDate.format( 'Y-MM-DD' ),
				};

				this.loading = true;

				jQuery.post( ScriptData.ajaxurl, data, ( response ) => {
					this.events  = response.events;
					this.loading = false;
				} );
			},
			getDayEventsIndex: function( date ) {
				return moment( date, 'Y-MMMM-DD' ).format( 'Y-MM-DD' );
			},
			getEventsForDay: function( date ) {
				let key = this.getDayEventsIndex( date );

				return this.events[key] ?? false;
			},
			dayHasEvents: function( day ) {
				return !! this.getEventsForDay( day );
			},
			monthHasEvents: function() {
				return Object.keys( this.events ).length !== 0;
			},
			goToThisMonth: function() {
				this.dateContext = moment();
			},
			addMonth: function() {
				this.dateContext = moment( this.dateContext ).add( 1, 'month' );
			},
			subtractMonth: function() {
				if ( ! this.disablePreviousMonth ) {
					this.dateContext = moment( this.dateContext ).subtract( 1, 'month' );
				}
			},
			isDayInPast: function( date ) {
				date = moment( date, 'Y-MMMM-D' );

				return date.isBefore( this.today, 'day' );
			},
			getDaySuffix( date ) {
				date = moment( date, 'Y-MMMM-D' );

				return date.format( 'Do' );
			},
			getWeekDay( date ) {
				date = moment( date, 'Y-MMMM-D' );

				return date.format( 'dddd' );
			},
		}
	}

</script>